var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TransitionUtils_1 = require("./utils/TransitionUtils");
var Component = (function (_super) {
    __extends(Component, _super);
    function Component() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getQueryValuesFromURL = TransitionUtils_1.default.getQueryValuesFromURL;
        _this.objectToQueryString = TransitionUtils_1.default.objectToQueryString;
        _this.jumpTo = TransitionUtils_1.default.jumpTo;
        _this.goBack = TransitionUtils_1.default.goBack;
        _this.transitTo = TransitionUtils_1.default.transitTo;
        _this.redirectTo = TransitionUtils_1.default.redirectTo;
        _this.updateQuery = TransitionUtils_1.default.updateQuery;
        return _this;
    }
    return Component;
}(React.Component));
exports.default = Component;
